import tempMeeApi from '../../../apis/tempMee';

export const getPromotions = async () => {
  const response = await tempMeeApi.get('/payment/admin/promotion-campaigns');

  return response.data;
};
